import React from "react";
import { withTranslation } from "react-i18next";
import BaseDialog from "../dialogs/baseDialog/BaseDialog";
import MarkDownViewer from "../markdownViewer/MarkDownViewer";

const MarkdownViewerDialog = props => {
  const { t } = props;
  let lang = props.lang.toLowerCase();
  //eslint-disable-next-line
  if (/\-/.test(lang)) lang = lang.split("-")[0];
  return (
    <BaseDialog
      show={props.show}
      onHide={props.onHide}
      title={props.title}
      body={(<MarkDownViewer lang={lang} text={props.text} />)}
      leftButtonText={t("DialogClose")}
      leftButtonVariant="black"
      leftButtonCallback={props.onHide}
      dialogApiError={props.dialogApiError}
    />
  );
};

export default withTranslation()(MarkdownViewerDialog);
